import React, { useState, useEffect } from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { TextField, Select, MenuItem, Button } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { fetchFestivals } from "../../../redux/festivalSlice";
import { createCoupon, updateCoupon } from "../../../redux/couponSlice";
import { Formik, Form } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import SuccessModal from "../../../components/Modals/SuccessfulModal";
import toast from "react-hot-toast";

export const COUPON_VALIDATOR = yup.object().shape({
  code: yup.string().required("Code is required."),
  description: yup.string().required("Description is required."),
  startDate: yup.date().nullable(),
  codeType: yup.string().required("Code Type is required."),
  discount: yup
    .number()
    .required("Discount is required.")
    .positive("Discount must be positive."),
  endDate: yup.date().nullable(),
  // festivalId: yup.string().required("Festival is required."),
});

const CouponForm = () => {
  const location = useLocation();
  const actionType = location.state?.actionType || "create";
  const coupon = location.state?.couponData || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  console.warn("location.state:::", actionType);

  // Fetch festivals from Redux state
  const festivalData = useSelector((state) => state.festival.festivalData);

  useEffect(() => {
    dispatch(fetchFestivals());
  }, [dispatch]);

  const handleCouponSubmit = async (values, { setSubmitting }) => {
    // if (
    //   new Date(values.startDate).getTime() > new Date(values.endDate).getTime()
    // ) {
    //   setErrorMessage("Start Date cannot be greater than End Date");
    //   setError(true);
    //   setSubmitting(false);
    //   return;
    // }
    setSubmitting(true);

    try {
      const couponData = {
        ...values,
        startDate: values.startDate
          ? dayjs(values.startDate).toISOString()
          : null,
        endDate: values.endDate ? dayjs(values.endDate).toISOString() : null,
        festivalId: values.festivalId
          ? values.festivalId
          : "66ba05290be7af0ee5277c18",
      };
      let couponId = coupon._id;
      console.log("====================================");
      console.log(
        "CopenID :",
        couponId,
        `\n`,
        couponData,
        `\n`,
        // coupon,
        `\n`,
        actionType
      );
      console.log("====================================");
      // let couponId = couponData._id;
      if (actionType === "edit") {
        await dispatch(updateCoupon({ couponId, couponData }));
        setSuccess(true);
        // toast.success("Coupon updated successfully!");
        navigate("/coupen-list");
      } else {
        await dispatch(createCoupon(couponData)).then((response) => {
          console.log("res ::::", response.payload);
          let result = response.payload.isSuccess;
          if (result === true) {
            setSuccess(true);
            setTimeout(() => {
              // try {
                navigate("/coupen-list");
              // } catch (error) { }
            }, 5000);
          } else {
             setSuccess(false);
          }
        })
        // toast.success("Coupon created successfully!");
      }
    } catch (err) {
      setError(true);
      setErrorMessage(err.response?.data?.msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{
        code: coupon.code || "",
        description: coupon.description || "",
        startDate: coupon.startDate
          ? dayjs(coupon.startDate).format("YYYY-MM-DD")
          : null,
        codeType: coupon.codeType || "percentage",
        discount: coupon.discount || 0,
        endDate: coupon.endDate
          ? dayjs(coupon.endDate).format("YYYY-MM-DD")
          : null,
        festivalId: coupon.festivalId || "",
      }}
      enableReinitialize
      validationSchema={COUPON_VALIDATOR}
      onSubmit={handleCouponSubmit}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <Form onSubmit={handleSubmit}>
          {/* Coupon Code */}
          <div className="card mt-3">
            <div className="card-body m-3">
              <div className="row">
                {/* Festival Name */}
                <div className="col-md-12 mb-3">
                  <div className="coupon_padding">
                    <p className="coupon_heading_text">Code</p>
                    <TextField
                      type="text"
                      name="code"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.code}
                      fullWidth
                      variant="outlined"
                    />
                    {errors.code && touched.code && (
                      <div className="error-text">{errors.code}</div>
                    )}
                  </div>
                </div>

                {/* Description */}
                <div className="col-md-12 mb-3">
                  <div className="coupon_padding">
                    <p className="coupon_heading_text">Description</p>
                    <TextField
                      multiline
                      rows={4}
                      name="description"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.description}
                      fullWidth
                      variant="outlined"
                    />
                    {errors.description && touched.description && (
                      <div className="error-text">{errors.description}</div>
                    )}
                  </div>
                </div>

                {/* Start Date */}
                <div className="col-md-6 mb-3">
                  <div className="coupon_padding">
                    <p className="coupon_heading_text">Start Date</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Start Date"
                        value={
                          values.startDate ? dayjs(values.startDate) : null
                        }
                        onChange={(newValue) =>
                          setFieldValue("startDate", newValue)
                        }
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                {/* End Date */}
                <div className="col-md-6 mb-3">
                  <div className="coupon_padding">
                    <p className="coupon_heading_text">End Date</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="End Date"
                        value={values.endDate ? dayjs(values.endDate) : null}
                        onChange={(newValue) =>
                          setFieldValue("endDate", newValue)
                        }
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                {/* Code Type */}
                <div className="col-md-6 mb-3">
                  <div className="coupon_padding">
                    <p className="coupon_heading_text">Code Type</p>
                    <TextField
                      type="text"
                      name="codeType"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.codeType}
                      fullWidth
                      variant="outlined"
                    />
                    {errors.codeType && touched.codeType && (
                      <div className="error-text">{errors.codeType}</div>
                    )}
                  </div>
                </div>

                {/* Discount */}
                <div className="col-md-6 mb-3">
                  <div className="coupon_padding">
                    <p className="coupon_heading_text">Discount</p>
                    <TextField
                      type="number"
                      name="discount"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.discount}
                      fullWidth
                      variant="outlined"
                    />
                    {errors.discount && touched.discount && (
                      <div className="error-text">{errors.discount}</div>
                    )}
                  </div>
                </div>

                {/* Festival Selection */}
                <div className="col-md-6 mb-3">
                  <div className="coupon_padding">
                    <p className="coupon_heading_text">Festival</p>
                    <Select
                      name="festivalId"
                      value={values.festivalId}
                      onChange={handleChange}
                      fullWidth
                      variant="outlined"
                    >
                      {festivalData?.length > 0 &&
                        festivalData.map((festival) => (
                          <MenuItem key={festival._id} value={festival._id}>
                            {festival.name}
                          </MenuItem>
                        ))}
                    </Select>
                    {/* {errors.festivalId && touched.festivalId && (
                      <div className="error-text">{errors.festivalId}</div>
                    )} */}
                  </div>
                </div>

                {/* Buttons */}
                {/* <div className="col-md-6 mb-3"> */}
                <div className="coupon_padding">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {actionType === "edit" ? "Update" : "Submit"}
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    style={{ marginLeft: "10px" }}
                    onClick={() => navigate("/coupen-list")}
                  >
                    Back
                  </Button>
                </div>
                {/* </div> */}

                {/* Success Modal */}
                {success && (
                  <SuccessModal
                    isOpen={success}
                    msg={`Coupon ${actionType} Successfully`}
                    navigatePage={"/coupen-list"}
                  />
                )}

                {/* Error Message */}
                {error && <div className="error-text">{errorMessage}</div>}
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CouponForm;
